import { render, staticRenderFns } from "./itemReleaseTypeManageList.vue?vue&type=template&id=a5a125e4&scoped=true"
import script from "./itemReleaseTypeManageList.vue?vue&type=script&lang=js"
export * from "./itemReleaseTypeManageList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseTypeManageList.vue?vue&type=style&index=0&id=a5a125e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a125e4",
  null
  
)

export default component.exports